var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOfferTag = function SvgOfferTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A5AFC3",
    d: "M13.209 7.408a1.517 1.517 0 1 0 0-3.034 1.517 1.517 0 0 0 0 3.034"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D1D9E9",
    d: "m16.992 8.591-.608-2.367v1.859c0 .85-.534 1.391-.534 1.391s-3.725 4.05-5.291 5.817-2.684.175-2.684.175l-2.558-2.458-.308.567a1.285 1.285 0 0 0 .508 1.733l5.4 2.942a1.27 1.27 0 0 0 1.733-.509l4.15-7.625a2.05 2.05 0 0 0 .192-1.517z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#A5AFC3",
    d: "M9.192 16.7c-.458 0-.891-.167-1.233-.484L3.534 12.15a1.821 1.821 0 0 1-.108-2.583l5.741-6.242a2.6 2.6 0 0 1 1.734-.833l3.966-.308a1.92 1.92 0 0 1 1.459.508c.391.358.616.867.616 1.4l.034 3.983c0 .667-.242 1.3-.692 1.792l-5.742 6.242a1.85 1.85 0 0 1-1.266.591h-.084m.834-12.584-5.742 6.242a.67.67 0 0 0-.175.475c0 .175.083.341.217.458l4.425 4.067a.7.7 0 0 0 .475.175.62.62 0 0 0 .458-.217l5.742-6.242c.25-.275.383-.625.383-.991l-.033-3.984a.72.72 0 0 0-.242-.55.76.76 0 0 0-.575-.2l-3.967.309a1.45 1.45 0 0 0-.958.458z"
  })));
};
export default SvgOfferTag;